import React, { FC, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import {
    clearStatus,
    selectClientSignupStatus,
    postClientSignupAsync
} from "../../features/client/clientSignupSlice";

import styled from "styled-components";

import Alert from "react-bootstrap/Alert";
import Card from "react-bootstrap/Card";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from "react-bootstrap/Spinner";

import { Quote } from 'react-bootstrap-icons';

import { RecruiterProfiles } from "../../common/data/recruiter-profiles";

type testimonial = { contact_name: string, contact_company: string, contact_position: string, testimonial_text: string };

const client_copy_content: {[type: string]: { testimonial: testimonial, middle_text: string } } = {
    'talent': { 
        testimonial: { contact_name: "Matthew Welch", contact_company: "Ripple", contact_position: "Talent Acquisition Lead", testimonial_text: "It's been a pleasure to work with Source Coders. They truly understood our business needs, I always felt confident when meeting their candidates as I know the team goes the extra mile to prep them. I'm very pleased with our hire and hope for more in the future. I'd highly recommend Source Coders to any tech team looking for top tier talent." },
        middle_text: "We have worked with a number of internal talent teams and are always available to offer help and advice, and sometimes coaching on technical recruiting, whether or not we are actively engaged."
    },
    'tech': { 
        testimonial: { contact_name: "Dan Driscoll", contact_company: "M10/Spekit/BitGo", contact_position: "VP of Engineering", testimonial_text: "I've had great success with SourceCoders over the past several years and several independent engagements with them. In each case, I sought specific talent profiles, arguably asking for impossible unicorn candidates. In particular, we had great success forming a foundational Rust development team, not the easiest talent to find, filter, and land. Of all the agency recruiters I've partnered with, only Stephen and SourceCoders team has consistently and reliably delivered to me precisely the candidates I was looking for, not wasting time on compromises or false potential. I fully intend to engage with Stephen and team at every future opportunity." },
        middle_text: "This allows us to better understand your technical requirements, find the right high-quality candidates and save your valuable time through the interview process."
    }
};

const checkboxes: { [id: string]: {label: string, value: boolean} } = {
    '1ceb71aa18': { label: 'Full Stack', value: false },
    'bf60b93d9a': { label: 'Front End', value: false },
    'c354788581': { label: 'Backend', value: false },
    'ecd327a158': { label: 'DevOps/SRE', value: false },
    '82090adc43': { label: 'SecOps/Security', value: false },
    '17db10a8eb': { label: 'Machine Learning/Data Science', value: false },
    '530b111783': { label: 'Mobile', value: false },
    'bbb3c9ab17': { label: 'Engineering Leadership', value: false }
};

const checkboxList = [
    '1ceb71aa18',
    'bf60b93d9a',
    'c354788581',
    'ecd327a158',
    '82090adc43',
    '17db10a8eb',
    '530b111783',
    'bbb3c9ab17'
];

type ClientPreferencesProps = {};

export const ClientPreferences: FC<ClientPreferencesProps> = () => {

    const dispatch = useAppDispatch();

    const status = useAppSelector(selectClientSignupStatus);

    const queryParams = new URLSearchParams(window.location.search);

    const emailParam = queryParams.get("email");
    const firstName = queryParams.get("first_name");
    const recruiterParam = queryParams.get("recruiter") || "ss";
    const recruiter_profile = RecruiterProfiles[recruiterParam] || RecruiterProfiles["ss"];
    const interestsParam = queryParams.get("interests");
    const hiringManagerTypeParam = queryParams.get("hm") || "tech";
    const client_copy = client_copy_content[hiringManagerTypeParam] || client_copy_content["tech"];

    // Construct the Client Interests object to intialize 
    if (interestsParam) {
        const interestTokens = interestsParam.split("-");
        for (var i in interestTokens) {
            const token = interestTokens[i];
            if(checkboxes[token] !== undefined) {
                checkboxes[token].value = true;
            }
        }
    }

    const errorAlertMessage = "I am very sorry. There seems to have been an error."
    const successAlertMessage = "Thank you for signing up."


    // Email field hooks
    const [email, setEmail] = useState(emailParam);
    const emailValue = String(email) || "";

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	}

    const [clientInterests, setClientInterests] = useState(checkboxes);

    const handleClientInterestsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setClientInterests(prevState => ({...prevState, [e.target.id]: { label: checkboxes[e.target.id].label, value: e.target.checked }}));
    }

    const submitHandler = (event: React.FormEvent) => {
        event.preventDefault();

        let combinedInterests : {[id: string]: boolean} = {}; 

        for (var interest in clientInterests) {
            combinedInterests[interest] = clientInterests[interest].value;
        }

        dispatch(postClientSignupAsync({email: emailValue, interests: combinedInterests}));
    }

    return (
        <>
            <Container>
                {status === "failed" &&
                    <Alert variant="danger" onClose={ () => dispatch(clearStatus()) } dismissible>
                        {errorAlertMessage}
                    </Alert>
                }
                {status === "success" &&
                    <Alert variant="success" onClose={ () => dispatch(clearStatus()) } dismissible>
                        {successAlertMessage}
                    </Alert>
                }
                <ContentSection className="w-100 m-auto">
                    <Form onSubmit={submitHandler}>
                        <h1 className="mb-3 fw-normal">Hello{firstName ? " " + firstName : ""},</h1>
                        <h5 className="mb-3 fw-normal">Great to connect! I'm looking forward to getting to know you. Please feel free to reach out to me at anytime. { recruiterParam == "ss" ? <>My cell phone is <a href="tel:1-310-913-6516">(310) 913-6516</a> and my email is <a href="mailto:stephen@sourcecoders.io">stephen@sourcecoders.io</a></> : "" } </h5>

                        
                        <Card className="mb-4 bg-light shadow-sm">
                            <Card.Body className="text-center">
                                <Card.Img className={"rounded-circle shadow mx-auto mt-2"} variant={"top"} src= { recruiter_profile.headshot } style={{maxWidth: '200px'}} />
                                <blockquote className="blockquote mb-0">
                                    <p>
                                        <Quote className="me-2" />
                                        { recruiter_profile.client_quote }
                                    </p>
                                    <footer className="blockquote-footer">
                                        { recruiter_profile.display_name + ", " + recruiter_profile.position }
                                    </footer>
                                </blockquote>
                            </Card.Body>
                        </Card>
                        

                        <h5 className="mb-3 fw-normal">We understand the unique challenges of finding and screening the right technical talent for your team. We are very technically proficient with a number of former software engineers on our recruiting team.</h5>
                        <h5 className="mb-3 fw-normal">{ client_copy.middle_text }</h5>
                        <h5 className="mb-3 fw-normal">Please see below what one of our valued clients {client_copy.testimonial.contact_name} had to say about working with us.</h5>

                        <Card className="mb-4 bg-light shadow-sm">
                            <Card.Body className="text-center">
                                <blockquote className="blockquote mb-0">
                                    <p>
                                        <Quote className="me-2" />
                                        { client_copy.testimonial.testimonial_text }
                                    </p>
                                    <footer className="blockquote-footer">
                                        { client_copy.testimonial.contact_name + ", " + client_copy.testimonial.contact_position + ", " +  client_copy.testimonial.contact_company }
                                    </footer>
                                </blockquote>
                            </Card.Body>
                        </Card>

                        <h5 className="mb-3 fw-normal">Please confirm your preferred contact email and the type of technical roles your company typically hires for.</h5>

                        <Form.Group className="mb-4" controlId="formBasicEmail">
                            <Form.Control required type="email" placeholder="Please enter your email" value={email || ''} onChange={ handleEmailChange } />
                            {/* <Form.Text className="text-muted">
                                Please confirm your preferred contact email
                            </Form.Text> */}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                            {checkboxList.map((checkbox, idx) => {
                                return (
                                    <Form.Check id={checkbox} key={checkbox} type="checkbox" label={clientInterests[checkbox].label} checked={clientInterests[checkbox].value} onChange={handleClientInterestsChange} />
                                );
                            })}
                        </Form.Group>

                        <Button variant="primary" type="submit" disabled={ status === 'loading' ? true : false }>
                            { status === 'loading' &&
                                <div>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="visually-hidden">Loading...</span> 
                                </div>
                            }
                            {status === 'loading' ? "" : "Submit"}
                        </Button>

                        {/* <a className="mt-3 link-secondary d-block" href="#">Opt out of all email comminications</a> */}
                    </Form>
                </ContentSection>
            </Container>
        </>
    );
}

const ContentSection = styled.div`
    max-width: 700px;
    padding: 15px;
`